<template>
	<div class="content-class">
		<v-layout class="filter-navigation">
			<b-o-input
				:input="{ type: 'select', label: 'Type de donnée', values: valueTypes }"
				v-model="valueType"
			></b-o-input>

			<b-o-input
				:input="{ type: 'select', label: 'Groupe', values: subBots, itemText: 'name', itemValue: '_id' }"
				v-if="type !== 'subBot' && subBots"
				v-model="subBot"
			></b-o-input>

			<b-o-input ref="inputFrom" :input="{ type: 'date', label: 'De' }" v-model="date.from"></b-o-input>
			<b-o-input ref="inputTo" :input="{ type: 'date', label: 'Jusqu\'au' }" v-model="date.to"></b-o-input>
		</v-layout>

		<dashboard-user-list
			ref="dashboard"
			:value-type="valueType"
			:navigation-variables="navigationVariables"
			:url="
				`users/navigations?filter=${subotFiltered ? `subBotsSended:$eq:${subotFiltered};` : ''}bots.bot:$eq:${
					$route.params.botId
				}`
			"
			:date="date"
		>
		</dashboard-user-list>
	</div>
</template>
<script>
import DashboardUserList from './dashboard.user.list'
import BOInput from '../../baseComponents/boInput.vue'

export default {
	components: { DashboardUserList, BOInput },
	props: ['type'],
	data() {
		return {
			valueType: 'valeur',
			subBot: null,
			date: {
				from: null,
				to: null,
			},
		}
	},
	computed: {
		subotFiltered() {
			return this.type === 'subBot' ? this.$store.getters.subBot._id : this.subBot
		},
		subBots() {
			if (this.$store.getters.bot.subBots) {
				return this.$store.getters.bot.subBots
			}
			return null
		},
		valueTypes() {
			if (this.$store.getters.bot.saveNavigationTime) {
				return ['valeur', 'dernier passage', 'temps total', 'Nombre de passage']
			}
			return ['valeur', 'dernier passage', 'Nombre de passage']
		},
		navigationVariables() {
			if (this.type === 'subBot') {
				return this.$store.getters.subBotNavigationVariables
			}

			if (this.subBot) {
				return this.$store.getters.botNavigationVariables.filter((el) => {
					return el.subBot === this.subBot
				})
			}
			return this.$store.getters.botNavigationVariables
		},
	},
	watch: {
		valueTypes: function() {
			if (!this.valueTypes.find((valueType) => valueType === this.valueType)) {
				this.valueType = this.valueTypes[0]
			}
		},
	},
}
</script>
<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;

	.filter-navigation {
		margin-left: auto;
		.layout {
			flex-grow: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard.vue